function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M35.64,26.43V8.87a2.94,2.94,0,0,0-2.93-2.93H15.15a2.94,2.94,0,0,0-2.93,2.93V26.43a2.94,2.94,0,0,0,2.93,2.93H32.71a2.94,2.94,0,0,0,2.93-2.93m-16.1-5.86,3,4,4.34-5.43,5.86,7.32H15.15ZM6.36,11.79V32.28a2.94,2.94,0,0,0,2.93,2.93H29.78V32.28H9.29V11.79Z",
    style: {
      fill: "#62a3ef"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotosIcon);
export default __webpack_public_path__ + "static/media/photos_icon.8462211942946681c2d998a4380c20fe.svg";
export { ForwardRef as ReactComponent };